import { IBaseConfig, IFormFieldFilter } from "@models/form/base-config";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardTable,
} from "@hardcode-kz/ui";
import { Validators } from "@angular/forms";
import { noWhitespaceValidator } from "@app/shared";
import { ResourceManagementEndpoints } from "@dmms/shared/data-access/resource-management/types/resource-management-endpoints";
import { IDeviceResponse } from "@dmms/shared/data-access/resource-management/models/device";

export class DeviceConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.Device;
  isCrudByModal = true;

  fields: IHardFormField[] = [
    {
      title: "dicTable.deviceId",
      name: "name",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required, noWhitespaceValidator],
      },
    },
    {
      title: "dicTable.imei",
      name: "externalId",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required, noWhitespaceValidator],
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];
  tableConfig: IHardTable<IDeviceResponse[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(3,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.deviceId",
        name: "name",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.imei",
        name: "externalId",
        type: HardTableColumnTypeEnum.Text,
      },
    ],
  };
}
